import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';
export function NoMoreSection() {
  const comparisons = [{
    problem: 'Sticky Resin',
    solution: 'Hard Cured Finish'
  }, {
    problem: 'Micro-bubbles',
    solution: 'Crystal Clear'
  }, {
    problem: 'Warped Pieces',
    solution: 'Perfectly Flat'
  }, {
    problem: 'Yellowing',
    solution: 'UV Stable'
  }];
  return <section className="py-20 bg-stone-100" data-id="element-66">
      <div className="container mx-auto px-4" data-id="element-67">
        <div className="text-center mb-12" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-69">
            No More...
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-70">
          {comparisons.map((item, idx) => <div key={idx} className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-71">
              <div className="grid grid-cols-2 h-32" data-id="element-72">
                <div className="bg-stone-200 relative flex items-center justify-center" data-id="element-73">
                  <div className="absolute inset-0 bg-stone-300 opacity-50 mix-blend-multiply" data-id="element-74"></div>
                  <XCircle className="w-8 h-8 text-stone-500 relative z-10" data-id="element-75" />
                </div>
                <div className="bg-teal-50 relative flex items-center justify-center" data-id="element-76">
                  <CheckCircle className="w-8 h-8 text-teal-500 relative z-10" data-id="element-77" />
                </div>
              </div>
              <div className="p-4 flex justify-between items-center text-sm font-medium" data-id="element-78">
                <span className="text-stone-400 line-through decoration-red-400" data-id="element-79">
                  {item.problem}
                </span>
                <span className="text-teal-700" data-id="element-80">{item.solution}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}